export default __webpack_public_path__ + "static/media/intro-activity.c98c898e.png";